import { Component, OnChanges, SimpleChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import {SureFlowLoopDetail} from '../../model/sure-flow-loop-detail';
import {SelectionSystemType} from '../../model/selection-system-type';
import {StringUtils} from '../../utils/string-utils';
import {WorkingSureFlowUnit} from '../../model/working-sure-flow-unit';
import {SureFlowAutoSelectInput} from '../../model/sure-flow-auto-select-input';
import { SureflowLoopConditionDetailComponent } from '../sureflow-loop-condition-detail/sureflow-loop-condition-detail.component';

import { MatTabGroup, MatTab, MatTabContent } from '@angular/material/tabs';

@Component({
    selector: 'app-sureflow-loop-detail',
    templateUrl: './sureflow-loop-detail.component.html',
    styleUrls: ['./sureflow-loop-detail.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatTabGroup, MatTab, MatTabContent, SureflowLoopConditionDetailComponent]
})
export class SureflowLoopDetailComponent implements OnChanges {

  readonly loopDetail = input.required<SureFlowLoopDetail>();
  readonly units = input.required<WorkingSureFlowUnit[]>();
  readonly invalidUnitIds = input.required<number[]>();
  readonly selectedUnitIds = input.required<number[]>();
  readonly systemType = input.required<SelectionSystemType>();
  readonly addUnit = output<SureFlowLoopDetail>();
  readonly editUnits = output<void>();
  readonly deleteUnits = output<void>();
  readonly copyUnits = output<void>();
  readonly addNonSureFlowUnit = output<SureFlowLoopDetail>();
  readonly recalculate = output<SureFlowLoopDetail>();
  readonly autoSelect = output<SureFlowAutoSelectInput>();
  readonly unitsRearranged = output<SureFlowLoopDetail>();
  readonly selectedUnitsChanged = output<WorkingSureFlowUnit[]>();

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  hasCooling(): boolean {
    return StringUtils.equalsIgnoreCase('C', this.systemType()?.primaryCoilApplication);
  }

  hasHeating(): boolean {
    return StringUtils.equalsIgnoreCase('H', this.systemType()?.primaryCoilApplication)
      || StringUtils.equalsIgnoreCase('H', this.systemType()?.secondaryCoilApplication);
  }

  addLoopUnit(detail: SureFlowLoopDetail): void {
    this.addUnit.emit(detail);
  }

  selectionChanged(units: WorkingSureFlowUnit[]) {
    this.selectedUnitsChanged.emit(units);
  }

  editLoopUnits(): void {
    this.editUnits.emit();
  }

  deleteLoopUnits(): void {
    this.deleteUnits.emit();
  }

  copyLoopUnits(): void {
    this.copyUnits.emit();
  }

  addNonSFUnit(detail: SureFlowLoopDetail): void {
    this.addNonSureFlowUnit.emit(detail);
  }

  recalculateLoop(detail: SureFlowLoopDetail): void {
    this.recalculate.emit(detail);
  }

  autoSelectUnits(detail: SureFlowAutoSelectInput): void {
    this.autoSelect.emit(detail);
  }

  rearrangeUnits(detail: SureFlowLoopDetail): void {
    this.unitsRearranged.emit(detail);
  }

}
